import dayjs from "dayjs";

export const BUSINESS_DAYS_SLA = 3;

export const BOTOES_INICIAIS = {
  isBtnCancelarOS: false,
  isBtnSuspenderOS: false,
  isBtnNegociarOS: false,
  isBtnDesnegociar: false,
  isBtnIniciarNegociacao: false,
  isBtnRetrocederOS: false,
  isBtnRestaurarOS: false,
  isBtnAvancarOS: false,
  isBtnAvancarPerfilVendas: false,
  isBtnEditarObservacaoOS: false,
  isBtnAtribuirAnalistaOS: false,
  isBtnTrocarClienteOS: false,
  isBtnAtualizarClienteOS: false,
  isBtnGerarBoletoOS: false,
  isBtnGerarPixOS: false,
  isBtnDataMigracao: false,
  isBtnDataEncerramento: false,
  isBtnCompletarOS: false,
  isBtnCarregadorDocOS: false,
  isBtnModalImportsAberturaAlteracaoEmpresa: false,
  isBtnModalImportsEnquadramentoEmpresa: false,
  isBtnModalImportBaixaEncerramentoEmpresa: false,
  isBtnReport: true,
};

/**
 * Dias úteis (seg-sex) entre duas datas, incluindo ambas as pontas.
 */
export function calcularDiasUteis(dataInicio, dataFim) {
  let diasUteis = 0;
  let cursor = dayjs(dataInicio);

  while (cursor.isBefore(dataFim, "day") || cursor.isSame(dataFim, "day")) {
    const diaSemana = cursor.day();
    if (diaSemana !== 0 && diaSemana !== 6) diasUteis++;
    cursor = cursor.add(1, "day");
  }

  return diasUteis;
}

function estadoInicial() {
  return {
    botoes: { ...BOTOES_INICIAIS },
    mostrarMensagem: false,
    alertInfo: "",
    avisoToast: null,
    isAlertNegociacaoInicialSituacaoDiasUteis: false,
    isAlertNegociacaoInicial: false,
    isAlertSolicitacaoServicoUltrapassou: false,
    isAlertProcessoFinalizado: false,
    isAlertCancelada: false,
    isAlertOrdemSuspensa: false,
    showQuadroSocioAdministrativo: true,
    showQuadroSocioAdministrativoRadio: true,
    showEmpresa: true,
    showAcessos: true,
    showFaturamento: true,
    situacaoInicialParaNegociacao: "",
  };
}

/* ------------------------------------------------------------------ */
/* Regras "grandes", uma por situação — mutuamente exclusivas (uma OS  */
/* só tem uma situação por vez). Cada uma espelha 1:1 o bloco original */
/* `if (situacao?.id === "X") {...}` do fetchData antigo.              */
/* Retornam `true` quando o bloco original tinha um `return` (ou seja, */
/* nenhuma regra posterior deve rodar).                                */
/* ------------------------------------------------------------------ */

function regraI({ suspensa, tipoId, marcar, estado }) {
  marcar({ isBtnAvancarOS: false });

  if (suspensa) {
    marcar({
      isBtnCancelarOS: true,
      isBtnRestaurarOS: true,
      isBtnEditarObservacaoOS: false,
      isBtnCarregadorDocOS: false,
      isBtnIniciarNegociacao: false,
      isBtnCompletarOS: false,
      isBtnSuspenderOS: false,
      isBtnDesnegociar: false,
    });
    return true;
  }

  marcar({
    isBtnEditarObservacaoOS: true,
    isBtnCarregadorDocOS: true,
    isBtnIniciarNegociacao: true,
    isBtnCompletarOS: true,
    isBtnDesnegociar: false,
    isBtnCancelarOS: tipoId !== "3",
    // (a checagem original de fgExecucaoSuspensa aqui embaixo nunca é alcançada,
    // pois já teríamos retornado no bloco acima — por isso isBtnSuspenderOS é sempre true)
    isBtnSuspenderOS: true,
  });
  estado.showEmpresa = false;
  estado.showAcessos = false;
  estado.showFaturamento = false;
  return false;
}

function regraIN({ suspensa, tipoId, marcar, estado }) {
  if (suspensa) {
    marcar({
      isBtnCancelarOS: true,
      isBtnRestaurarOS: true,
      isBtnSuspenderOS: false,
      isBtnAvancarOS: false,
      isBtnEditarObservacaoOS: false,
      isBtnCarregadorDocOS: false,
      isBtnDesnegociar: false,
      isBtnCompletarOS: false,
      isBtnTrocarClienteOS: false,
    });
    return true;
  }

  marcar({
    isBtnCancelarOS: true,
    isBtnSuspenderOS: true,
    isBtnEditarObservacaoOS: true,
    isBtnCarregadorDocOS: true,
    isBtnDesnegociar: true,
    isBtnCompletarOS: true,
    isBtnTrocarClienteOS: false,
  });
  estado.showEmpresa = false;
  estado.showFaturamento = false;
  estado.isAlertOrdemSuspensa = false;

  if (tipoId === "1") {
    estado.showAcessos = true;
    estado.showFaturamento = true;
  } else {
    estado.showAcessos = false;
  }
  return false;
}

function regraS({ suspensa, tipoId, marcar, estado }) {
  if (suspensa) {
    marcar({
      isBtnCancelarOS: true,
      isBtnRestaurarOS: true,
      isBtnSuspenderOS: false,
      isBtnRetrocederOS: false,
      isBtnEditarObservacaoOS: false,
      isBtnAtribuirAnalistaOS: false,
      isBtnTrocarClienteOS: false,
      isBtnGerarBoletoOS: false,
      isBtnGerarPixOS: false,
      isBtnCarregadorDocOS: false,
      isBtnAvancarOS: false,
      isBtnNegociarOS: false,
    });
    return true;
  }

  marcar({
    isBtnCancelarOS: true,
    isBtnSuspenderOS: true,
    isBtnEditarObservacaoOS: true,
    isBtnAtribuirAnalistaOS: true,
    isBtnTrocarClienteOS: true,
    isBtnGerarBoletoOS: true,
    isBtnGerarPixOS: true,
    isBtnCarregadorDocOS: true,
  });

  if (tipoId === "1") marcar({ isBtnIniciarNegociacao: false });
  if (["1", "2", "3", "4", "5", "101", "102", "103", "106", "10301"].includes(tipoId)) {
    marcar({ isBtnAvancarOS: true, isBtnNegociarOS: true });
  }
  if (tipoId === "3") marcar({ isBtnTrocarClienteOS: true, isBtnDataMigracao: true });

  estado.isAlertOrdemSuspensa = false;
  return false;
}

function regraSN({ suspensa, tipoId, marcar }) {
  if (suspensa) {
    marcar({
      isBtnCancelarOS: true,
      isBtnRestaurarOS: true,
      isBtnSuspenderOS: false,
      isBtnIniciarNegociacao: false,
      isBtnAvancarOS: false,
      isBtnAtribuirAnalistaOS: false,
      isBtnEditarObservacaoOS: false,
      isBtnCarregadorDocOS: false,
      isBtnTrocarClienteOS: false,
      isBtnAtualizarClienteOS: false,
      isBtnGerarBoletoOS: false,
      isBtnGerarPixOS: false,
    });
    return true;
  }

  if (tipoId === "1") {
    marcar({
      isBtnCancelarOS: true,
      isBtnSuspenderOS: true,
      isBtnEditarObservacaoOS: true,
      isBtnCarregadorDocOS: true,
      isBtnIniciarNegociacao: true,
      isBtnGerarBoletoOS: true,
      isBtnGerarPixOS: true,
      isBtnTrocarClienteOS: true,
      isBtnAtribuirAnalistaOS: true,
    });
  }

  if (["2", "10301"].includes(tipoId)) {
    marcar({
      isBtnCancelarOS: true,
      isBtnSuspenderOS: true,
      isBtnAvancarOS: true,
      isBtnEditarObservacaoOS: true,
      isBtnCarregadorDocOS: true,
      isBtnIniciarNegociacao: true,
      isBtnAtribuirAnalistaOS: true,
      isBtnTrocarClienteOS: true,
      isBtnAtualizarClienteOS: true,
      isBtnGerarBoletoOS: true,
      isBtnGerarPixOS: true,
    });
  }

  if (["3", "102"].includes(tipoId)) {
    marcar({
      isBtnCancelarOS: true,
      isBtnSuspenderOS: true,
      isBtnIniciarNegociacao: true,
      isBtnAvancarOS: true,
      isBtnAtribuirAnalistaOS: true,
      isBtnEditarObservacaoOS: true,
      isBtnCarregadorDocOS: true,
      isBtnTrocarClienteOS: true,
      isBtnAtualizarClienteOS: true,
      isBtnGerarBoletoOS: true,
      isBtnGerarPixOS: true,
    });
  }
  return false;
}

function regraP({ suspensa, tipoId, marcar, mensagem, estado }) {
  if (suspensa) {
    marcar({
      isBtnCancelarOS: true,
      isBtnRestaurarOS: true,
      isBtnRetrocederOS: false,
      isBtnSuspenderOS: false,
      isBtnAvancarOS: false,
      isBtnEditarObservacaoOS: false,
      isBtnAtribuirAnalistaOS: false,
      isBtnAtualizarClienteOS: false,
      isBtnTrocarClienteOS: false,
      isBtnGerarBoletoOS: false,
      isBtnGerarPixOS: false,
      isBtnCarregadorDocOS: false,
      isBtnIniciarNegociacao: false,
    });
    return true;
  }

  mensagem("Pagamento da Ordem de Serviço identificado.");
  estado.isAlertNegociacaoInicialSituacaoDiasUteis = false;
  estado.isAlertSolicitacaoServicoUltrapassou = false;
  estado.showAcessos = true;
  estado.showFaturamento = true;

  marcar({
    isBtnCancelarOS: true,
    isBtnAtualizarClienteOS: true,
    isBtnTrocarClienteOS: true,
    isBtnSuspenderOS: true,
    isBtnRetrocederOS: true,
    isBtnAvancarOS: true,
    isBtnEditarObservacaoOS: true,
    isBtnAtribuirAnalistaOS: true,
    isBtnGerarBoletoOS: true,
    isBtnGerarPixOS: true,
    isBtnCarregadorDocOS: true,
    isBtnAvancarPerfilVendas: true,
    isBtnIniciarNegociacao: false,
    isBtnNegociarOS: false,
  });

  if (["2", "3", "101", "102", "106"].includes(tipoId)) marcar({ isBtnAtualizarClienteOS: true });
  if (tipoId === "3") marcar({ isBtnDataMigracao: true });
  return false;
}

function regraPDOC({ suspensa, tipoId, dadosOS, marcar, mensagem, estado }) {
  if (suspensa) {
    marcar({
      isBtnCancelarOS: true,
      isBtnRestaurarOS: true,
      isBtnSuspenderOS: false,
      isBtnRetrocederOS: false,
      isBtnAvancarOS: false,
      isBtnEditarObservacaoOS: false,
      isBtnAtribuirAnalistaOS: false,
      isBtnTrocarClienteOS: false,
      isBtnGerarBoletoOS: false,
      isBtnGerarPixOS: false,
      isBtnCarregadorDocOS: false,
      isBtnAtualizarClienteOS: false,
    });
    return true;
  }

  mensagem("Aguardando o cliente carregar os documentos e informações necessárias.");
  if (!dadosOS.cliente) {
    mensagem("Necessário atribuir a identificação do cliente para esta Ordem de Serviço.");
  }

  marcar({
    isBtnCancelarOS: true,
    isBtnSuspenderOS: true,
    isBtnRetrocederOS: true,
    isBtnAvancarOS: true,
    isBtnEditarObservacaoOS: true,
    isBtnAtribuirAnalistaOS: true,
    isBtnTrocarClienteOS: true,
    isBtnGerarBoletoOS: true,
    isBtnGerarPixOS: true,
    isBtnCarregadorDocOS: true,
    isBtnAtualizarClienteOS: true,
    isBtnIniciarNegociacao: false,
  });

  estado.showQuadroSocioAdministrativo = false;
  estado.showAcessos = true;
  estado.showFaturamento = true;

  if (tipoId === "3") marcar({ isBtnDataMigracao: true });
  return false;
}

function regraVDOC({ suspensa, tipoId, marcar, mensagem, estado }) {
  if (suspensa) {
    marcar({
      isBtnCancelarOS: true,
      isBtnRestaurarOS: true,
      isBtnRetrocederOS: false,
      isBtnSuspenderOS: false,
      isBtnAvancarOS: false,
      isBtnEditarObservacaoOS: false,
      isBtnAtribuirAnalistaOS: false,
      isBtnTrocarClienteOS: false,
      isBtnGerarBoletoOS: false,
      isBtnGerarPixOS: false,
      isBtnCarregadorDocOS: false,
      isBtnAtualizarClienteOS: false,
    });
    return true;
  }

  mensagem("Necessário verificar a documentação solicitada.");
  marcar({
    isBtnCancelarOS: true,
    isBtnSuspenderOS: true,
    isBtnRetrocederOS: true,
    isBtnAvancarOS: true,
    isBtnEditarObservacaoOS: true,
    isBtnAtribuirAnalistaOS: true,
    isBtnTrocarClienteOS: true,
    isBtnGerarBoletoOS: true,
    isBtnGerarPixOS: true,
    isBtnCarregadorDocOS: true,
    isBtnAtualizarClienteOS: true,
    isBtnIniciarNegociacao: false,
  });
  estado.showAcessos = true;
  estado.showFaturamento = true;
  if (tipoId === "3") marcar({ isBtnDataMigracao: true });
  return false;
}

function regraVCCM({ suspensa, tipoId, marcar, mensagem, estado }) {
  mensagem("É necessário carregar o Documento de Viabilidade da Prefeitura para prosseguir.");

  if (suspensa) {
    marcar({
      isBtnCancelarOS: true,
      isBtnRestaurarOS: true,
      isBtnSuspenderOS: false,
      isBtnEditarObservacaoOS: false,
      isBtnAtribuirAnalistaOS: false,
      isBtnTrocarClienteOS: false,
      isBtnAtualizarClienteOS: false,
      isBtnGerarBoletoOS: false,
      isBtnGerarPixOS: false,
      isBtnCarregadorDocOS: false,
      isBtnRetrocederOS: false,
      isBtnAvancarOS: false,
      isBtnDataMigracao: false,
    });
    return true;
  }

  marcar({
    isBtnCancelarOS: true,
    isBtnSuspenderOS: true,
    isBtnEditarObservacaoOS: true,
    isBtnAtribuirAnalistaOS: true,
    isBtnTrocarClienteOS: true,
    isBtnAtualizarClienteOS: true,
    isBtnGerarBoletoOS: true,
    isBtnGerarPixOS: true,
    isBtnRetrocederOS: true,
    isBtnAvancarOS: true,
    isBtnIniciarNegociacao: false,
  });
  if (tipoId === "3") marcar({ isBtnDataMigracao: true });
  estado.showAcessos = true;
  estado.showFaturamento = true;
  estado.showEmpresa = true;

  if (["1", "4"].includes(tipoId)) marcar({ isBtnModalImportsAberturaAlteracaoEmpresa: true });
  if (tipoId === "3") marcar({ isBtnModalImportsEnquadramentoEmpresa: true });
  if (tipoId === "4") marcar({ isBtnDataMigracao: false });
  if (tipoId === "5") marcar({ isBtnDataMigracao: false, isBtnModalImportBaixaEncerramentoEmpresa: true });
  return false;
}

function regraVCND({ suspensa, tipoId, marcar, mensagem }) {
  mensagem("Necessário verificar débitos junto às esferas Federal, Estadual e Municipal.");

  if (suspensa) {
    marcar({
      isBtnCancelarOS: true,
      isBtnRestaurarOS: true,
      isBtnDataEncerramento: true,
      isBtnTrocarClienteOS: false,
      isBtnSuspenderOS: false,
      isBtnEditarObservacaoOS: false,
      isBtnAtribuirAnalistaOS: false,
      isBtnAtualizarClienteOS: false,
      isBtnGerarBoletoOS: false,
      isBtnGerarPixOS: false,
      isBtnRetrocederOS: false,
      isBtnAvancarOS: false,
      isBtnCarregadorDocOS: false,
    });
    return true;
  }

  marcar({
    isBtnCancelarOS: true,
    isBtnSuspenderOS: true,
    isBtnEditarObservacaoOS: true,
    isBtnAtribuirAnalistaOS: true,
    isBtnTrocarClienteOS: true,
    isBtnAtualizarClienteOS: true,
    isBtnGerarBoletoOS: true,
    isBtnGerarPixOS: true,
    isBtnRetrocederOS: true,
    isBtnAvancarOS: true,
    isBtnCarregadorDocOS: true,
    isBtnNegociarOS: false,
    isBtnIniciarNegociacao: false,
  });
  if (tipoId === "5") marcar({ isBtnModalImportBaixaEncerramentoEmpresa: true });
  if (tipoId === "3") marcar({ isBtnDataMigracao: true });
  return false;
}

function regraVENF({ suspensa, tipoId, marcar, mensagem, estado }) {
  if (suspensa) {
    marcar({
      isBtnCancelarOS: true,
      isBtnRestaurarOS: true,
      isBtnSuspenderOS: false,
      isBtnEditarObservacaoOS: false,
      isBtnAtribuirAnalistaOS: false,
      isBtnTrocarClienteOS: false,
      isBtnAtualizarClienteOS: false,
      isBtnGerarBoletoOS: false,
      isBtnGerarPixOS: false,
      isBtnRetrocederOS: false,
      isBtnAvancarOS: false,
      isBtnCarregadorDocOS: false,
    });
    return true;
  }

  mensagem("Necessário verificar as credenciais do emissor de Notas Fiscais.");
  marcar({
    isBtnCancelarOS: true,
    isBtnSuspenderOS: true,
    isBtnEditarObservacaoOS: true,
    isBtnAtribuirAnalistaOS: true,
    isBtnTrocarClienteOS: true,
    isBtnAtualizarClienteOS: true,
    isBtnGerarBoletoOS: true,
    isBtnGerarPixOS: true,
    isBtnRetrocederOS: true,
    isBtnAvancarOS: true,
    isBtnCarregadorDocOS: true,
    isBtnNegociarOS: false,
  });
  estado.showAcessos = true;
  estado.showFaturamento = true;
  if (tipoId === "3") marcar({ isBtnDataMigracao: true });
  return false;
}

function regraARFB({ suspensa, tipoId, marcar, mensagem, estado }) {
  if (suspensa) {
    marcar({
      isBtnCancelarOS: true,
      isBtnRestaurarOS: true,
      isBtnDataMigracao: false,
      isBtnSuspenderOS: false,
      isBtnEditarObservacaoOS: false,
      isBtnAtribuirAnalistaOS: false,
      isBtnTrocarClienteOS: false,
      isBtnAtualizarClienteOS: false,
      isBtnGerarBoletoOS: false,
      isBtnGerarPixOS: false,
      isBtnCarregadorDocOS: false,
      isBtnRetrocederOS: false,
      isBtnAvancarOS: false,
    });
    return true;
  }

  mensagem("Necessário elaborar a documentação para Receita Federal.");
  marcar({
    isBtnCancelarOS: true,
    isBtnSuspenderOS: true,
    isBtnEditarObservacaoOS: true,
    isBtnAtribuirAnalistaOS: true,
    isBtnTrocarClienteOS: true,
    isBtnAtualizarClienteOS: true,
    isBtnGerarBoletoOS: true,
    isBtnGerarPixOS: true,
    isBtnCarregadorDocOS: true,
    isBtnRetrocederOS: true,
    isBtnAvancarOS: true,
    isBtnIniciarNegociacao: false,
  });
  estado.showEmpresa = true;
  estado.showAcessos = true;
  estado.showFaturamento = true;

  if (tipoId === "3") marcar({ isBtnDataMigracao: true });
  if (["1", "4"].includes(tipoId)) marcar({ isBtnModalImportsAberturaAlteracaoEmpresa: true });
  if (tipoId === "3") marcar({ isBtnModalImportsEnquadramentoEmpresa: true });
  if (tipoId === "5") marcar({ isBtnModalImportBaixaEncerramentoEmpresa: true });
  return false;
}

function regraEJCM({ suspensa, tipoId, marcar, mensagem, estado }) {
  if (suspensa) {
    marcar({
      isBtnCancelarOS: true,
      isBtnRestaurarOS: true,
      isBtnSuspenderOS: false,
      isBtnEditarObservacaoOS: false,
      isBtnAtribuirAnalistaOS: false,
      isBtnTrocarClienteOS: false,
      isBtnAtualizarClienteOS: false,
      isBtnGerarBoletoOS: false,
      isBtnGerarPixOS: false,
      isBtnCarregadorDocOS: false,
      isBtnRetrocederOS: false,
      isBtnAvancarOS: false,
    });
    return true;
  }

  mensagem("Necessário elaborar a documentação para protocolar na JCM (Junta Comercial).");
  marcar({
    isBtnCancelarOS: true,
    isBtnSuspenderOS: true,
    isBtnEditarObservacaoOS: true,
    isBtnAtribuirAnalistaOS: true,
    isBtnTrocarClienteOS: true,
    isBtnAtualizarClienteOS: true,
    isBtnGerarBoletoOS: true,
    isBtnGerarPixOS: true,
    isBtnCarregadorDocOS: true,
    isBtnRetrocederOS: true,
    isBtnAvancarOS: true,
    isBtnIniciarNegociacao: false,
  });
  estado.showEmpresa = true;
  estado.showAcessos = true;
  estado.showFaturamento = true;

  if (["4", "3"].includes(tipoId)) marcar({ isBtnDataMigracao: false });
  if (["1", "4"].includes(tipoId)) marcar({ isBtnModalImportsAberturaAlteracaoEmpresa: true });
  if (tipoId === "3") marcar({ isBtnModalImportsEnquadramentoEmpresa: true });
  if (tipoId === "5") marcar({ isBtnModalImportBaixaEncerramentoEmpresa: true });
  return false;
}

function regraAJCM({ suspensa, tipoId, marcar, mensagem, estado }) {
  if (suspensa) {
    marcar({
      isBtnCancelarOS: true,
      isBtnRestaurarOS: true,
      isBtnSuspenderOS: false,
      isBtnEditarObservacaoOS: false,
      isBtnAtribuirAnalistaOS: false,
      isBtnTrocarClienteOS: false,
      isBtnAtualizarClienteOS: false,
      isBtnGerarBoletoOS: false,
      isBtnGerarPixOS: false,
      isBtnCarregadorDocOS: false,
      isBtnRetrocederOS: false,
      isBtnAvancarOS: false,
      isBtnNegociarOS: false,
      isBtnIniciarNegociacao: false,
    });
    return true;
  }

  mensagem("Necessário aguardar análise da JCM (Junta Comercial).");
  marcar({
    isBtnCancelarOS: true,
    isBtnSuspenderOS: true,
    isBtnEditarObservacaoOS: true,
    isBtnAtribuirAnalistaOS: true,
    isBtnTrocarClienteOS: true,
    isBtnAtualizarClienteOS: true,
    isBtnGerarBoletoOS: true,
    isBtnGerarPixOS: true,
    isBtnCarregadorDocOS: true,
    isBtnRetrocederOS: true,
    isBtnAvancarOS: true,
    isBtnNegociarOS: false,
    isBtnIniciarNegociacao: false,
  });
  estado.showQuadroSocioAdministrativoRadio = true;

  if (tipoId === "3") marcar({ isBtnDataMigracao: true });
  if (["1", "4"].includes(tipoId)) marcar({ isBtnModalImportsAberturaAlteracaoEmpresa: true });
  if (tipoId === "3") marcar({ isBtnModalImportsEnquadramentoEmpresa: true });
  if (tipoId === "5") marcar({ isBtnModalImportBaixaEncerramentoEmpresa: true });
  return false;
}

function regraECCM({ suspensa, tipoId, marcar, mensagem, estado }) {
  if (suspensa) {
    marcar({
      isBtnCancelarOS: true,
      isBtnRestaurarOS: true,
      isBtnSuspenderOS: false,
      isBtnEditarObservacaoOS: false,
      isBtnAtribuirAnalistaOS: false,
      isBtnTrocarClienteOS: false,
      isBtnAtualizarClienteOS: false,
      isBtnGerarBoletoOS: false,
      isBtnGerarPixOS: false,
      isBtnCarregadorDocOS: false,
      isBtnRetrocederOS: false,
      isBtnAvancarOS: false,
      isBtnDataMigracao: false,
    });
    return true;
  }

  mensagem("Necessário elaborar a documentação para protocolar na CCM (Cadastro de Contribuintes Mobiliários) da Prefeitura.");
  marcar({
    isBtnCancelarOS: true,
    isBtnSuspenderOS: true,
    isBtnEditarObservacaoOS: true,
    isBtnAtribuirAnalistaOS: true,
    isBtnTrocarClienteOS: true,
    isBtnAtualizarClienteOS: true,
    isBtnGerarBoletoOS: true,
    isBtnGerarPixOS: true,
    isBtnCarregadorDocOS: true,
    isBtnRetrocederOS: true,
    isBtnAvancarOS: true,
  });
  estado.showEmpresa = true;
  estado.showAcessos = true;
  estado.showFaturamento = true;

  if (tipoId === "3") marcar({ isBtnDataMigracao: true });
  if (tipoId === "5") marcar({ isBtnDataEncerramento: true });
  // Correção: o original usava aqui a variável de estado antiga do componente
  // (`dados.tipo?.id`, ainda não atualizada nesse ponto do fluxo) em vez do tipo
  // recém consultado. Usamos sempre o dado fresco, que é o comportamento pretendido.
  if (["1", "4"].includes(tipoId)) marcar({ isBtnModalImportsAberturaAlteracaoEmpresa: true });
  if (tipoId === "3") marcar({ isBtnModalImportsEnquadramentoEmpresa: true });
  if (tipoId === "5") marcar({ isBtnModalImportBaixaEncerramentoEmpresa: true });
  return false;
}

function regraACCM({ suspensa, tipoId, marcar, mensagem, estado }) {
  if (suspensa) {
    marcar({
      isBtnCancelarOS: true,
      isBtnRestaurarOS: true,
      isBtnSuspenderOS: false,
      isBtnEditarObservacaoOS: false,
      isBtnAtribuirAnalistaOS: false,
      isBtnTrocarClienteOS: false,
      isBtnAtualizarClienteOS: false,
      isBtnGerarBoletoOS: false,
      isBtnGerarPixOS: false,
      isBtnCarregadorDocOS: false,
      isBtnRetrocederOS: false,
      isBtnAvancarOS: false,
      isBtnDataMigracao: false,
      isBtnDataEncerramento: false,
    });
    return true;
  }


  marcar({
    isBtnCancelarOS: true,
    isBtnSuspenderOS: true,
    isBtnEditarObservacaoOS: true,
    isBtnAtribuirAnalistaOS: true,
    isBtnTrocarClienteOS: true,
    isBtnAtualizarClienteOS: true,
    isBtnGerarBoletoOS: true,
    isBtnGerarPixOS: true,
    isBtnRetrocederOS: true,
    isBtnAvancarOS: true,
    isBtnCarregadorDocOS: true,
    isBtnIniciarNegociacao: false,
    isBtnNegociarOS: false,
  });
  estado.showEmpresa = true;
  estado.showAcessos = true;
  estado.showFaturamento = true;

  if (["3", "4"].includes(tipoId)) marcar({ isBtnDataMigracao: true });
  if (tipoId === "5") marcar({ isBtnDataEncerramento: true });
  if (["1", "4"].includes(tipoId)) marcar({ isBtnModalImportsAberturaAlteracaoEmpresa: true });
  if (tipoId === "3") marcar({ isBtnModalImportsEnquadramentoEmpresa: true });
  if (tipoId === "5") marcar({ isBtnModalImportBaixaEncerramentoEmpresa: true });
  return false;
}

function regraEDOC({ suspensa, tipoId, marcar, mensagem, estado }) {
  if (suspensa) {
    marcar({
      isBtnCancelarOS: true,
      isBtnRestaurarOS: true,
      isBtnSuspenderOS: false,
      isBtnRetrocederOS: false,
      isBtnAvancarOS: false,
      isBtnEditarObservacaoOS: false,
      isBtnAtribuirAnalistaOS: false,
      isBtnTrocarClienteOS: false,
      isBtnAtualizarClienteOS: false,
      isBtnGerarBoletoOS: false,
      isBtnGerarPixOS: false,
      isBtnCarregadorDocOS: false,
      isBtnDataMigracao: false,
      isBtnDataEncerramento: false,
    });
    return true;
  }

  marcar({
    isBtnCancelarOS: true,
    isBtnSuspenderOS: true,
    isBtnRetrocederOS: true,
    isBtnAvancarOS: true,
    isBtnEditarObservacaoOS: true,
    isBtnAtribuirAnalistaOS: true,
    isBtnTrocarClienteOS: true,
    isBtnAtualizarClienteOS: true,
    isBtnGerarBoletoOS: true,
    isBtnGerarPixOS: true,
    isBtnCarregadorDocOS: true,
    isBtnNegociarOS: false,
    isBtnIniciarNegociacao: false,
  });
  estado.showEmpresa = true;
  estado.showAcessos = true;
  estado.showFaturamento = true;

  if (["1", "4"].includes(tipoId)) marcar({ isBtnModalImportsAberturaAlteracaoEmpresa: true });
  if (tipoId === "3") marcar({ isBtnModalImportsEnquadramentoEmpresa: true, isBtnDataMigracao: true });
  if (tipoId === "5") marcar({ isBtnModalImportBaixaEncerramentoEmpresa: true, isBtnDataEncerramento: true });
  return false;
}

function regraFDOC({ suspensa, tipoId, marcar, mensagem, estado }) {
  if (suspensa) {
    marcar({
      isBtnCancelarOS: true,
      isBtnRestaurarOS: true,
      isBtnSuspenderOS: false,
      isBtnEditarObservacaoOS: false,
      isBtnAtribuirAnalistaOS: false,
      isBtnTrocarClienteOS: false,
      isBtnAtualizarClienteOS: false,
      isBtnGerarBoletoOS: false,
      isBtnGerarPixOS: false,
      isBtnRetrocederOS: false,
      isBtnAvancarOS: false,
      isBtnCarregadorDocOS: false,
      isBtnDataMigracao: false,
      isBtnDataEncerramento: false,
    });
    return true;
  }

  mensagem("Cliente efetuou o download dos documentos referentes à empresa.");
  marcar({
    isBtnCancelarOS: true,
    isBtnSuspenderOS: true,
    isBtnEditarObservacaoOS: true,
    isBtnAtribuirAnalistaOS: true,
    isBtnTrocarClienteOS: true,
    isBtnAtualizarClienteOS: true,
    isBtnGerarBoletoOS: true,
    isBtnGerarPixOS: true,
    isBtnRetrocederOS: true,
    isBtnAvancarOS: true,
    isBtnCarregadorDocOS: true,
    isBtnNegociarOS: false,
    isBtnIniciarNegociacao: false,
  });
  estado.showEmpresa = true;
  estado.showAcessos = true;
  estado.showFaturamento = true;

  if (tipoId === "3") marcar({ isBtnDataMigracao: true });
  if (tipoId === "4") estado.showQuadroSocioAdministrativoRadio = false;
  if (tipoId === "5") marcar({ isBtnDataEncerramento: true });
  return false;
}

function regraCCCM({ marcar }) {
  marcar({ isBtnRetrocederOS: true, isBtnAvancarOS: true });
  return false;
}

function regraERT({ suspensa, tipoId, marcar, mensagem }) {
  if (suspensa) {
    marcar({
      isBtnCancelarOS: true,
      isBtnRestaurarOS: true,
      isBtnSuspenderOS: false,
      isBtnEditarObservacaoOS: false,
      isBtnAtribuirAnalistaOS: false,
      isBtnTrocarClienteOS: false,
      isBtnAtualizarClienteOS: false,
      isBtnGerarBoletoOS: false,
      isBtnGerarPixOS: false,
      isBtnRetrocederOS: false,
      isBtnAvancarOS: false,
      isBtnCarregadorDocOS: false,
      isBtnDataMigracao: false,
    });
    return true;
  }

  mensagem("Ncessário realizar registro do Regime Tributário da Empresa.");
  marcar({
    isBtnCancelarOS: true,
    isBtnSuspenderOS: true,
    isBtnEditarObservacaoOS: true,
    isBtnAtribuirAnalistaOS: true,
    isBtnTrocarClienteOS: true,
    isBtnAtualizarClienteOS: true,
    isBtnGerarBoletoOS: true,
    isBtnGerarPixOS: true,
    isBtnRetrocederOS: true,
    isBtnAvancarOS: true,
    isBtnCarregadorDocOS: true,
    isBtnNegociarOS: false,
  });

  // ATENÇÃO — bug do original preservado de propósito (ver aviso na resposta desta etapa):
  // as duas condições abaixo usavam "||" em vez de "&&" ("situacao === 'E-RT' || tipo === '3'"),
  // e como já estamos dentro do bloco de E-RT essa condição é sempre verdadeira, não importa
  // o tipo. A 2ª linha sempre roda logo depois e sobrescreve a 1ª, deixando isBtnDataMigracao
  // sempre `false` para qualquer tipo em E-RT.
  marcar({ isBtnDataMigracao: true });
  marcar({ isBtnDataMigracao: false });

  if (tipoId === "4") marcar({ isBtnModalImportsAberturaAlteracaoEmpresa: true });
  if (tipoId === "3") marcar({ isBtnModalImportsEnquadramentoEmpresa: true });
  return false;
}

function regraEENF({ suspensa, tipoId, marcar, mensagem, estado }) {
  if (suspensa) {
    marcar({
      isBtnCancelarOS: true,
      isBtnRestaurarOS: true,
      isBtnSuspenderOS: false,
      isBtnEditarObservacaoOS: false,
      isBtnAtribuirAnalistaOS: false,
      isBtnTrocarClienteOS: false,
      isBtnAtualizarClienteOS: false,
      isBtnGerarBoletoOS: false,
      isBtnGerarPixOS: false,
      isBtnRetrocederOS: false,
      isBtnAvancarOS: false,
      isBtnCarregadorDocOS: false,
    });
    return true;
  }

  mensagem("Necessário credenciar Emissor das Notas Fiscais da Empresa.");
  marcar({
    isBtnCancelarOS: true,
    isBtnSuspenderOS: true,
    isBtnEditarObservacaoOS: true,
    isBtnAtribuirAnalistaOS: true,
    isBtnTrocarClienteOS: true,
    isBtnAtualizarClienteOS: true,
    isBtnGerarBoletoOS: true,
    isBtnGerarPixOS: true,
    isBtnRetrocederOS: true,
    isBtnAvancarOS: true,
    isBtnCarregadorDocOS: true,
    isBtnNegociarOS: false,
  });
  estado.showEmpresa = true;
  estado.showAcessos = true;
  estado.showFaturamento = true;

  if (["1", "4"].includes(tipoId)) marcar({ isBtnModalImportsAberturaAlteracaoEmpresa: true });
  return false;
}

function regraMTE({ suspensa, marcar, mensagem }) {
  if (suspensa) {
    marcar({
      isBtnCancelarOS: true,
      isBtnRestaurarOS: true,
      isBtnSuspenderOS: false,
      isBtnEditarObservacaoOS: false,
      isBtnAtribuirAnalistaOS: false,
      isBtnTrocarClienteOS: false,
      isBtnAtualizarClienteOS: false,
      isBtnGerarBoletoOS: false,
      isBtnGerarPixOS: false,
      isBtnRetrocederOS: false,
      isBtnAvancarOS: false,
      isBtnCarregadorDocOS: false,
      isBtnDataMigracao: false,
    });
    return true;
  }

  mensagem("Necessário alterar o Tipo Jurídico, Porte e/ou Regime Tributário da Empresa.");
  marcar({
    isBtnCancelarOS: true,
    isBtnSuspenderOS: true,
    isBtnEditarObservacaoOS: true,
    isBtnAtribuirAnalistaOS: true,
    isBtnTrocarClienteOS: true,
    isBtnAtualizarClienteOS: true,
    isBtnGerarBoletoOS: true,
    isBtnGerarPixOS: true,
    isBtnRetrocederOS: true,
    isBtnAvancarOS: true,
    isBtnCarregadorDocOS: true,
    isBtnDataMigracao: true,
  });
  // No original havia aqui uma checagem `situacao === "E-RT" && tipo === "3"`, mas dentro
  // do bloco de M-TE a situação nunca é "E-RT" — o trecho nunca era executado. Removido.
  return false;
}

function regraERBE({ suspensa, tipoId, marcar, mensagem }) {
  if (suspensa) {
    marcar({
      isBtnCancelarOS: true,
      isBtnRestaurarOS: true,
      isBtnSuspenderOS: false,
      isBtnEditarObservacaoOS: false,
      isBtnAtribuirAnalistaOS: false,
      isBtnTrocarClienteOS: false,
      isBtnAtualizarClienteOS: false,
      isBtnGerarBoletoOS: false,
      isBtnGerarPixOS: false,
      isBtnRetrocederOS: false,
      isBtnAvancarOS: false,
      isBtnCarregadorDocOS: false,
      isBtnDataEncerramento: false,
    });
    return true;
  }

  mensagem("Necessário realizar registro do Regime de Baixa da Empresa.");
  marcar({
    isBtnCancelarOS: true,
    isBtnSuspenderOS: true,
    isBtnEditarObservacaoOS: true,
    isBtnAtribuirAnalistaOS: true,
    isBtnTrocarClienteOS: true,
    isBtnAtualizarClienteOS: true,
    isBtnGerarBoletoOS: true,
    isBtnGerarPixOS: true,
    isBtnRetrocederOS: true,
    isBtnAvancarOS: true,
    isBtnCarregadorDocOS: true,
    isBtnDataEncerramento: true,
    isBtnNegociarOS: false,
  });
  if (tipoId === "5") marcar({ isBtnModalImportBaixaEncerramentoEmpresa: true });
  return false;
}

function regraEDE({ suspensa, tipoId, marcar, mensagem }) {
  if (suspensa) {
    marcar({
      isBtnCancelarOS: true,
      isBtnRestaurarOS: true,
      isBtnSuspenderOS: false,
      isBtnEditarObservacaoOS: false,
      isBtnAtribuirAnalistaOS: false,
      isBtnTrocarClienteOS: false,
      isBtnAtualizarClienteOS: false,
      isBtnGerarBoletoOS: false,
      isBtnGerarPixOS: false,
      isBtnRetrocederOS: false,
      isBtnAvancarOS: false,
      isBtnCarregadorDocOS: false,
      isBtnDataEncerramento: false,
    });
    return true;
  }

  mensagem("Necessário emitir Declaração de Extinção da Empresa.");
  marcar({
    isBtnCancelarOS: true,
    isBtnSuspenderOS: true,
    isBtnEditarObservacaoOS: true,
    isBtnAtribuirAnalistaOS: true,
    isBtnTrocarClienteOS: true,
    isBtnAtualizarClienteOS: true,
    isBtnGerarBoletoOS: true,
    isBtnGerarPixOS: true,
    isBtnRetrocederOS: true,
    isBtnAvancarOS: true,
    isBtnCarregadorDocOS: true,
    isBtnDataEncerramento: true,
    isBtnNegociarOS: false,
  });
  if (tipoId === "5") marcar({ isBtnModalImportBaixaEncerramentoEmpresa: true });
  return false;
}

function regraF({ suspensa, marcar, estado }) {
  if (suspensa) {
    marcar({
      isBtnCancelarOS: true,
      isBtnRestaurarOS: true,
      isBtnEditarObservacaoOS: false,
      isBtnAtribuirAnalistaOS: false,
      isBtnTrocarClienteOS: false,
      isBtnAtualizarClienteOS: false,
      isBtnRetrocederOS: false,
      isBtnCarregadorDocOS: false,
    });
    return true;
  }

  estado.isAlertProcessoFinalizado = true;
  estado.mostrarMensagem = false;
  marcar({
    isBtnEditarObservacaoOS: true,
    isBtnAtribuirAnalistaOS: true,
    isBtnTrocarClienteOS: true,
    isBtnAtualizarClienteOS: true,
    isBtnRetrocederOS: true,
    isBtnCarregadorDocOS: true,
    isBtnIniciarNegociacao: false,
    isBtnAvancarOS: false,
    isBtnCancelarOS: false,
    isBtnSuspenderOS: false,
    isBtnGerarBoletoOS: false,
    isBtnGerarPixOS: false,
  });
  estado.showAcessos = true;
  estado.showFaturamento = true;
  estado.showEmpresa = true;
  return false;
}

function regraC({ marcar, estado }) {
  estado.isAlertCancelada = true;
  estado.showEmpresa = true;
  estado.showAcessos = true;
  estado.showFaturamento = true;
  marcar({ isBtnTrocarClienteOS: false, isBtnCarregadorDocOS: true, isBtnEditarObservacaoOS: true });
  estado.mostrarMensagem = false;
  return false;
}

const REGRAS_POR_SITUACAO = {
  I: regraI,
  "I-N": regraIN,
  S: regraS,
  "S-N": regraSN,
  P: regraP,
  "P-DOC": regraPDOC,
  "V-DOC": regraVDOC,
  "V-CCM": regraVCCM,
  "V-CND": regraVCND,
  "V-ENF": regraVENF,
  "A-RFB": regraARFB,
  "E-JCM": regraEJCM,
  "A-JCM": regraAJCM,
  "E-CCM": regraECCM,
  "A-CCM": regraACCM,
  "E-DOC": regraEDOC,
  "F-DOC": regraFDOC,
  "C-CCM": regraCCCM,
  "E-RT": regraERT,
  "E-ENF": regraEENF,
  "M-TE": regraMTE,
  "E-RBE": regraERBE,
  "E-DE": regraEDE,
  F: regraF,
  C: regraC,
};

const COMBOS_ALTERACAO_PROLABORE = [
  ["S", "10373"],
  ["V-DOC", "10373"],
  ["E-PS", "10373"],
  ["P-DOC", "10373"],
  ["V-SND", "10373"],
];

/**
 * Calcula, de forma pura, todo o estado visual da tela de tratamento da OS
 * (quais botões aparecem, qual alerta mostrar, quais seções exibir) a partir
 * dos dados que acabaram de ser consultados na API.
 *
 * Não faz chamadas de API nem `setState` — quem chama decide o que fazer com
 * o resultado (ver useOrdemServico.js).
 */
export function calcularEstadoOS(dadosOS, agora) {
  if (!dadosOS) return estadoInicial();

  const situacaoId = dadosOS.situacao?.id;
  const tipoId = dadosOS.tipo?.id;
  const suspensa = dadosOS.fgExecucaoSuspensa === true;

  const estado = estadoInicial();
  const marcar = (patch) => Object.assign(estado.botoes, patch);
  const mensagem = (texto) => {
    estado.mostrarMensagem = true;
    estado.alertInfo = texto;
  };

  // --- passos que sempre rodam, independente da situação -------------
  if (!dadosOS.cliente) marcar({ isBtnTrocarClienteOS: true, isBtnAtualizarClienteOS: false });

  const qsa = dadosOS.empresa?.qsa;
  estado.showQuadroSocioAdministrativoRadio = Array.isArray(qsa) && qsa.length > 0;

  if (suspensa) estado.isAlertOrdemSuspensa = true;

  if (["P-CCM", "P-JCM", "E-CCM", "E-RT"].includes(situacaoId)) {
    marcar({ isBtnAvancarOS: true, isBtnRetrocederOS: true, isBtnTrocarClienteOS: false });
    estado.avisoToast = "Favor clicar no botão 'Avançar' para prosseguir com esta ordem.";
  }

  if (!dadosOS.cliente?.id) {
    mensagem("Necessário atribuir a identificação do cliente para esta Ordem de Serviço.");
  }

  // (preserva a checagem literal do original, inclusive o campo inexistente "situacaoa")
  if (dadosOS.usuarioAtribuicao?.id === "" || (dadosOS.usuarioAtribuicao?.id === null && dadosOS.situacaoa?.id === "C")) {
    mensagem("Necessário atribuir analista para esta Ordem de Serviço.");
  }

  if (situacaoId === "I-N") estado.situacaoInicialParaNegociacao = "Inicial";
  if (situacaoId === "E-DOC" && tipoId === "10373") marcar({ isBtnNegociarOS: false });

  if ((situacaoId === "F" && tipoId === "10371") || (situacaoId === "F" && tipoId === "102")) {
    marcar({
      isBtnCancelarOS: false,
      isBtnSuspenderOS: false,
      isBtnAvancarOS: false,
      isBtnNegociarOS: false,
      isBtnGerarBoletoOS: false,
      isBtnGerarPixOS: false,
    });
  }

  if (["I", "I-N", "I-F"].includes(situacaoId)) {
    const diasUteis = calcularDiasUteis(dayjs(dadosOS.dataSituacao), agora);
    const critico = diasUteis > BUSINESS_DAYS_SLA;
    estado.isAlertNegociacaoInicialSituacaoDiasUteis = critico;
    estado.isAlertNegociacaoInicial = !critico;
  }

  // Bloco combinado S/S-N (roda ANTES do bloco completo de cada um, ver abaixo)
  if (situacaoId === "S" || situacaoId === "S-N") {
    if (situacaoId === "S") {
      marcar({
        isBtnRetrocederOS: false,
        isBtnModalImportsAberturaAlteracaoEmpresa: false,
        isBtnModalImportBaixaEncerramentoEmpresa: false,
        isBtnModalImportsEnquadramentoEmpresa: false,
      });
      estado.showEmpresa = true;
    }
    if (situacaoId === "S-N" && tipoId === "3") marcar({ isBtnAvancarOS: false });
    if (situacaoId === "S-N" && tipoId === "2") marcar({ isBtnAvancarOS: true });

    const diferencaEmDias = agora.diff(dayjs(dadosOS.dataSituacao), "day");
    if (diferencaEmDias > BUSINESS_DAYS_SLA + 2) {
      estado.isAlertSolicitacaoServicoUltrapassou = true;
    } else {
      mensagem("Aguardando a confirmação de pagamento pela rede bancária. Este processo pode demorar até 2 dias úteis");
    }
    if (situacaoId === "S" && tipoId === "1") {
      marcar({ isBtnAvancarOS: true });
      estado.showAcessos = true;
      estado.showFaturamento = true;
    }
  }

  // --- bloco "grande" exclusivo da situação atual ---------------------
  const regra = REGRAS_POR_SITUACAO[situacaoId];
  const parar = regra ? regra({ suspensa, tipoId, dadosOS, marcar, mensagem, estado }) : false;

  if (!parar) {
    // Sobreposição: situações de Alteração de valor de Pró-labore de Sócio (DP)
    if (COMBOS_ALTERACAO_PROLABORE.some(([s, t]) => situacaoId === s && tipoId === t)) {
      if (suspensa) {
        marcar({ isBtnCancelarOS: true, isBtnRestaurarOS: true });
        marcar({
          isBtnCancelarOS: false,
          isBtnSuspenderOS: false,
          isBtnRetrocederOS: false,
          isBtnAvancarOS: false,
          isBtnGerarBoletoOS: false,
          isBtnGerarPixOS: false,
        });
      } else {
        marcar({
          isBtnCancelarOS: true,
          isBtnSuspenderOS: true,
          isBtnRetrocederOS: true,
          isBtnAvancarOS: true,
          isBtnGerarBoletoOS: true,
          isBtnGerarPixOS: true,
        });
      }
    }

    // Regra final duplicada no original: força o botão de atualizar cliente em A-JCM
    if (situacaoId === "A-JCM") marcar({ isBtnAtualizarClienteOS: true });
  }

  return estado;
}
